import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Row, Col, Container, Dropdown } from 'react-bootstrap';
import s from './ItemList.css';
import rs from '../../../storeCommon.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
//local
import messages from '../../../../locale/messages';
import CustomPagination from '../../../CustomPagination/CustomPagination';
import Link from '../../../Link/Link';
import { Button, FormControl, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

//Images
import VegIcon from '../../../../../public/StoreIcon/veg.svg';
import NonVegIcon from '../../../../../public/StoreIcon/non-veg.svg';
import VegetarianIcon from '../../../../../public/StoreIcon/vegetarian.svg';
import { FiEdit2, FiTrash2, FiPlus, FiPlusSquare, FiSearch, FiArrowLeft, FiCopy, FiArrowRight } from 'react-icons/fi';


import updateItemStatus from '../../../../actions/shop/menu/updateItemStatus';
import deleteItem from '../../../../actions/shop/menu/deleteItem';
import duplicateItem from '../../../../actions/shop/menu/duplicateItem';
import editItem from '../../../../actions/shop/menu/editItem';
import moveItem from '../../../../actions/shop/menu/moveItem';
import fetchMenusAndSubmenus from '../../../../actions/shop/menu/fetchMenusAndSubmenus';

import updateSubMenuStatus from '../../../../actions/shop/menu/updateSubMenuStatus';
import deleteSubMenu from '../../../../actions/shop/menu/deleteSubMenu';
import duplicateSubMenu from '../../../../actions/shop/menu/duplicateSubMenu';
import editSubMenu from '../../../../actions/shop/menu/editSubMenu';

import { openSubMenuModal, openModal, closeModal } from '../../../../actions/siteadmin/modalActions';
import AddSubMenuModal from '../SubMenu/AddSubMenuModal';
import CurrencyConverter from '../../../CurrencyConverter';

import history from '../../../../history';
import { api, itemImageUploadDir } from '../../../../config'
import ConfirmationPopup from '../../../Common/ConfirmationPopup';
import SwitchButton from '../../../Common/Switch/Switch';
import DefaultImage from '../../../../../public/StoreIcon/defaultFood.svg';
import debounce from '../../../../helpers/debounce';

const itemTypeIcons = { 1: VegIcon, 2: NonVegIcon, 3: VegetarianIcon };
const itemTypeLabels = { 1: messages.itemType1, 2: messages.itemType2, 3: messages.itemType3 };

class ItemList extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      currentPage: 1,
      searchList: '',
      showSearch: false,
      duplicatingId: null,
      duplicatingSubMenuId: null,
      newItemId: null,
      moveModalVisible: false,
      moveSelectedItemId: null,
      moveSelectedItemName: '',
      moveTargetSubMenuId: '',
      moveTargetMenuId: '',
      availableMenus: [],
      isLoadingMenus: false,
    };

    this.handleDuplicate = this.handleDuplicate.bind(this);
    this.handleDuplicateSubMenu = this.handleDuplicateSubMenu.bind(this);

    this.paginationData = this.paginationData.bind(this);
    this.handleKeywordSearch = debounce(this.handleKeywordSearch.bind(this), 250);
    this.handleStatus = this.handleStatus.bind(this);
    this.handleMoveItem = this.handleMoveItem.bind(this);
    this.openMoveModal = this.openMoveModal.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.calculateOverallAmount = this.calculateOverallAmount.bind(this);
    this.isValueDefined = this.isValueDefined.bind(this);
  }

  isValueDefined(value) {
    if (value && value !== undefined && value !== null && String(value) !== '') {
      return true
    }

    return false;
  }

  async handleDuplicate(id) {
    const { duplicateItem, menuId } = this.props;
    const { currentPage } = this.state;
    this.setState({ duplicatingId: id });
    const newId = await duplicateItem(id, currentPage, menuId);
    this.setState({ duplicatingId: null, newItemId: newId });
    if (newId) {
      setTimeout(() => this.setState({ newItemId: null }), 2500);
    }
  }

  async handleDuplicateSubMenu(id, currentPage) {
    const { duplicateSubMenu, menuId, closeModal, itemDetails: { refetch } } = this.props;
    this.setState({ duplicatingSubMenuId: id });
    const newId = await duplicateSubMenu(id, currentPage, menuId);
    // Refetch the query the component is actually watching so the new sub menu
    // shows up immediately (the action's refetchQueries variables don't match
    // this component's active query variables).
    if (newId) {
      await refetch({ currentPage, menuId });
    }
    this.setState({ duplicatingSubMenuId: null });
    closeModal('copySubMenuModal');
  }

  async openMoveModal(itemId, itemName) {
    this.setState({ 
      moveModalVisible: true, 
      moveSelectedItemId: itemId, 
      moveSelectedItemName: itemName,
      moveTargetMenuId: '', 
      moveTargetSubMenuId: '',
      isLoadingMenus: true
    });
    const menus = await this.props.fetchMenusAndSubmenus();
    this.setState({
      availableMenus: menus || [],
      isLoadingMenus: false
    });
  }

  async handleMoveItem() {
    const { moveItem, menuId } = this.props;
    const { currentPage, moveSelectedItemId, moveTargetMenuId, moveTargetSubMenuId } = this.state;
    if (!moveTargetMenuId || !moveTargetSubMenuId || !moveSelectedItemId) return;
    this.setState({ moveModalVisible: false });
    await moveItem(moveSelectedItemId, Number(moveTargetSubMenuId), Number(moveTargetMenuId), currentPage, menuId);
    this.setState({ moveSelectedItemId: null, moveTargetSubMenuId: '', moveTargetMenuId: '' });
  }

  handleKeywordSearch(searchList) {
    const { itemDetails: { refetch }, menuId } = this.props;

    const variables = {
      currentPage: 1,
      searchList,
      menuId
    };

    this.setState({ currentPage: 1, searchList })
    refetch(variables);
  }

  handleSearchClick(searchList) {
    const { itemDetails: { refetch }, menuId } = this.props
    const variables = {
      currentPage: 1,
      searchList: searchList,
      menuId: menuId
    }
    this.setState({ currentPage: 1 })
    refetch(variables)
  }

  handleSearchChange(e) {
    const self = this
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout)
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(() => {
        self.handleSearchClick(self.state.searchList)
      }, 450)
    })
  }

  async handleDelete(id, currentPage, section) {
    const { deleteItem, itemDetails: { refetch }, menuId, deleteSubMenu, closeModal } = this.props;
    const variables = { currentPage, menuId };

    if (section === 'subMenu') {
      await deleteSubMenu(id, currentPage, menuId)
      await closeModal('subMenuDeleteModal')
      refetch(variables)
    } else {
      await deleteItem(id, currentPage, menuId);
      await closeModal('itemDeleteModal');
      refetch(variables);
    }
  };

  paginationData(currentPage) {
    const { itemDetails: { refetch }, menuId } = this.props;
    const variables = { currentPage, menuId };

    this.setState({ currentPage });
    refetch(variables);
  };

  async handleStatus(id, status, currentPage, section) {
    const { updateItemStatus, itemDetails: { refetch }, menuId, updateSubMenuStatus } = this.props;
    const variables = { currentPage, menuId };

    if (section === 'subMenu') {
      await updateSubMenuStatus(id, status, currentPage, menuId)
      refetch(variables)
    } else {
      await updateItemStatus(id, status, currentPage, menuId);
      refetch(variables);
    }
  };

  calculateOverallAmount(amount, itemTax, shopTax, shopTaxAndFee) {
    const baseAmount = Number(amount) || 0;
    if (!(baseAmount > 0)) return baseAmount;

    const serviceFeePercent = shopTaxAndFee && shopTaxAndFee.serviceFee ? Number(shopTaxAndFee.serviceFee) : 0;
    const shopTotalTaxPercent = shopTaxAndFee && shopTaxAndFee.totalTax !== undefined
      ? Number(shopTaxAndFee.totalTax)
      : (shopTax !== undefined ? Number(shopTax) : 0);
    const taxCalculationType = shopTaxAndFee && shopTaxAndFee.taxCalculationType
      ? shopTaxAndFee.taxCalculationType
      : 'SERVICE_FEE_FIRST';

    const itemTaxPercent = itemTax ? Number(itemTax) : 0;
    const effectiveTaxPercent = shopTotalTaxPercent + itemTaxPercent;

    let withFirstComponent = baseAmount;
    let finalAmount = baseAmount;

    if (taxCalculationType === 'TAX_FIRST') {
      withFirstComponent = withFirstComponent + (withFirstComponent * (effectiveTaxPercent / 100));
      finalAmount = withFirstComponent + (withFirstComponent * (serviceFeePercent / 100));
    } else {
      withFirstComponent = withFirstComponent + (withFirstComponent * (serviceFeePercent / 100));
      finalAmount = withFirstComponent + (withFirstComponent * (effectiveTaxPercent / 100));
    }

    return finalAmount;
  }

  calculateItemPriceWithDiscount(amount, itemTax, shopTax, shopTaxAndFee, discountType, discountValue) {
    const totalPrice = this.calculateOverallAmount(amount, itemTax, shopTax, shopTaxAndFee);
    if (discountType === 'percentage') {
      return totalPrice - (totalPrice * (discountValue / 100));
    } else if (discountType === 'fixed') {
      return totalPrice - discountValue;
    }
    return totalPrice;
  }

  render() {
    const { itemDetails, openSubMenuModal, menuId, editItem, editSubMenu, duplicateItem, modalData, hideSearchAndPagination } = this.props;
    const { closeModal, openModal, subMenuDeleteModal, itemDeleteModal, copySubMenuModal, profile } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage, showSearch, duplicatingId, duplicatingSubMenuId, newItemId } = this.state;

    return (
      <div className={'mainContainer'}>

        <Modal show={this.state.moveModalVisible} onHide={() => this.setState({ moveModalVisible: false, moveSelectedItemId: null, moveTargetSubMenuId: '', moveTargetMenuId: '' })}>
          <Modal.Header closeButton>
            <Modal.Title>{formatMessage(messages.moveItemTitle)} - {this.state.moveSelectedItemName}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {this.state.isLoadingMenus ? (
               <div className="text-center py-4">
                 <span className="spinner-border spinner-border-sm text-danger" role="status" aria-hidden="true" />
               </div>
            ) : (
               <>
                <FormControl 
                  as="select" 
                  value={this.state.moveTargetMenuId} 
                  onChange={(e) => this.setState({ moveTargetMenuId: e.target.value, moveTargetSubMenuId: '' })}
                  className="mb-3"
                >
                  <option value="">{formatMessage(messages.chooseMenu)}</option>
                  {this.state.availableMenus.map(m => (
                      <option key={m.id} value={m.id}>{m.menuName}</option>
                  ))}
                </FormControl>

                {this.state.moveTargetMenuId && (
                  <FormControl 
                    as="select" 
                    value={this.state.moveTargetSubMenuId} 
                    onChange={(e) => this.setState({ moveTargetSubMenuId: e.target.value })}
                  >
                    <option value="">{formatMessage(messages.chooseSubMenu)}</option>
                    {this.state.availableMenus
                      .find(m => String(m.id) === String(this.state.moveTargetMenuId))
                      ?.subMenus?.map(sm => (
                        <option key={sm.id} value={sm.id}>{sm.name}</option>
                      ))
                    }
                  </FormControl>
                )}
               </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ moveModalVisible: false, moveSelectedItemId: null, moveTargetSubMenuId: '', moveTargetMenuId: '' })}>
              {formatMessage(messages.cancelButton)}
            </Button>
            <Button variant="danger" onClick={this.handleMoveItem} disabled={!this.state.moveTargetSubMenuId || !this.state.moveTargetMenuId}>
              {formatMessage(messages.moveAction)}
            </Button>
          </Modal.Footer>
        </Modal>

        <ConfirmationPopup
          modalStatus={subMenuDeleteModal}
          title={formatMessage(messages.deleteMenuTitle)}
          body={formatMessage(messages.deleteConfirmation)}
          closeModal={() => closeModal('subMenuDeleteModal')}
          popupButtonLeftName={formatMessage(messages.cancelButton)}
          popupButtonRightName={formatMessage(messages.deleteAction)}
          popupButtonLeftFunction={() => closeModal('subMenuDeleteModal')}
          popupButtonRightFunction={() => this.handleDelete(modalData.id, modalData.currentPage, 'subMenu')}
        />

        <ConfirmationPopup
          modalStatus={copySubMenuModal}
          loading={duplicatingSubMenuId !== null}
          title={formatMessage(messages.copySubMenuTitle)}
          body={formatMessage(messages.copySubMenuConfirmation)}
          closeModal={() => closeModal('copySubMenuModal')}
          popupButtonLeftName={formatMessage(messages.cancelButton)}
          popupButtonRightName={formatMessage(messages.duplicateSubMenu)}
          popupButtonLeftFunction={() => closeModal('copySubMenuModal')}
          popupButtonRightFunction={() => this.handleDuplicateSubMenu(modalData.id, modalData.currentPage)}
        />

        <ConfirmationPopup
          modalStatus={itemDeleteModal}
          title={formatMessage(messages.deleteMenuTitle)}
          body={formatMessage(messages.deleteConfirmation)}
          closeModal={() => closeModal('itemDeleteModal')}
          popupButtonLeftName={formatMessage(messages.cancelButton)}
          popupButtonRightName={formatMessage(messages.deleteAction)}
          popupButtonLeftFunction={() => closeModal('itemDeleteModal')}
          popupButtonRightFunction={() => this.handleDelete(modalData.id, modalData.currentPage, 'item')}
        />

        <Container fluid>
          <AddSubMenuModal />

          {/* Top header row: back arrow | title | search toggle */}
          <div className="d-flex align-items-center gap-2 mb-3">
            <Button variant="light" className="rounded-circle p-0 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 38, height: 38 }} onClick={() => history.push('/store/menu')}>
              <FiArrowLeft size={20} />
            </Button>
            <h2 className={cx(s.pageTitle, 'flex-grow-1')}>
              {itemDetails && itemDetails.getAllSubMenu && itemDetails.getAllSubMenu.menuName}
            </h2>
            {!hideSearchAndPagination &&
              <Button variant="light" className="rounded-circle p-0 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 38, height: 38 }} onClick={() => this.setState({ showSearch: !showSearch })}>
                <FiSearch size={18} />
              </Button>
            }
          </div>

          {/* Collapsible search + add sub menu */}
          {!hideSearchAndPagination && showSearch &&
            <div className={s.searchRow}>
              <FormControl
                type='text'
                placeholder={formatMessage(messages.search)}
                onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)}
                className={cx(rs.formControlInputStore, 'formControlInputStoreRTL')}
                autoFocus
              />
            </div>
          }
          {!hideSearchAndPagination &&
            <div className={cx(s.addSubMenuRow, 'mb-4')}>
              <Button variant="outline-danger" className="py-4 d-inline-flex align-items-center justify-content-center gap-2 w-100 border-dashed" onClick={() => openSubMenuModal(menuId)}>
                <FiPlusSquare size={15} />
                <FormattedMessage {...messages.addSubMenu} />
              </Button>
            </div>
          }

          {itemDetails && itemDetails.getAllSubMenu && itemDetails.getAllSubMenu.results && itemDetails.getAllSubMenu.results.length > 0 &&
            itemDetails.getAllSubMenu.results.map((item, index) => (
              <div key={item.id} className={cx(s.subMenuBlock, item.isEnable === false && s.subMenuBlockDisabled)}>

                {/* Inactive banner */}
                {item.isEnable === false &&
                  <div className={cx(s.disabledBanner, 'bg-secondary text-white')}>
                    <FormattedMessage {...messages.inactive} />
                  </div>
                }

                {/* Sub-menu header row */}
                {!hideSearchAndPagination &&
                  <div className={s.subMenuRow}>
                    <span className={s.subMenuName}>{item.name}</span>
                    <div className={s.subMenuActions}>
                      <Dropdown className={s.actionDropdownWrap}>
                        <Dropdown.Toggle variant="light">
                          {formatMessage(messages.editItem)}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className={s.dropdownMenu}>
                          <div className={s.dropdownSwitchItem}>
                            <span className={s.dropdownSwitchLabel}>
                              {item.isEnable ? formatMessage(messages.active) : formatMessage(messages.inactive)}
                            </span>
                            <SwitchButton
                              value={item.isEnable ? '1' : '0'}
                              handleSwitch={(e) => this.handleStatus(item.id, String(e), currentPage, 'subMenu')}
                              switchOnLabel={''}
                              switchOffLabel={''}
                            />
                          </div>
                          <Dropdown.Divider />
                          <Dropdown.Item className={s.dropdownItem} onClick={() => editSubMenu(item.id)}>
                            <FiEdit2 size={14} />
                            {formatMessage(messages.editItem)}
                          </Dropdown.Item>
                          <Dropdown.Item
                            className={s.dropdownItem}
                            disabled={duplicatingSubMenuId === item.id}
                            onClick={() => openModal('copySubMenuModal', { id: item.id, modalName: 'copySubMenuModal', currentPage })}
                          >
                            {duplicatingSubMenuId === item.id
                              ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                              : <FiCopy size={14} />
                            }
                            {formatMessage(messages.duplicateSubMenu)}
                          </Dropdown.Item>
                          <Dropdown.Item
                            className={cx(s.dropdownItem, s.dropdownItemDelete)}
                            onClick={() => openModal('subMenuDeleteModal', { id: item.id, modalName: 'subMenuDeleteModal', currentPage })}
                          >
                            <FiTrash2 size={14} />
                            {formatMessage(messages.deleteAction)}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                      <Link
                        to={`/store/menu/${item.menuId}/item/${item.id}/add`}
                        className="btn btn-outline-danger d-inline-flex align-items-center gap-2"
                      >
                        <FiPlus size={15} />
                        {formatMessage(messages.addItem)}
                      </Link>
                    </div>
                  </div>
                }

                {/* Empty state */}
                {(!item.item || item.item.length === 0) &&
                  <div className="text-center text-muted py-4 px-3">
                    <FormattedMessage {...messages.subMenuEmpty} />
                  </div>
                }

                {/* Item rows */}
                {item && item.item && item.item.map((itemData, index2) => {
                  const itemPrice = this.calculateOverallAmount(itemData.price, itemData.tax, itemData.shopTax, itemData.shopTaxAndFee);
                  const itemPriceWithDiscount = this.calculateItemPriceWithDiscount(
                    itemData.price, itemData.tax, itemData.shopTax, itemData.shopTaxAndFee,
                    itemData.discountType, itemData.discountValue
                  );
                  const hasDiscount = itemData.discountValue > 0 && itemData.discountType && itemData.discountType !== 'none';
                  return (
                    <div key={itemData.id} className={cx(s.itemRow, newItemId === itemData.id && s.itemRowNew)}>
                      {/* Left: image + info */}
                      <div className={s.itemLeft}>
                        <div
                          className={cx(s.itemThumb, !itemData.isEnable && s.inactive)}
                          style={{ backgroundImage: `url(${itemData.image ? api.apiEndpoint + itemImageUploadDir + itemData.image : DefaultImage})` }}
                        />
                        <div className={s.itemInfo}>
                          <span className={cx(s.itemName, !itemData.isEnable && 'text-muted')}>{itemData.itemName}</span>
                          <div className={s.itemPriceRow}>
                            {/* Original price — strikethrough when discounted (muted when inactive) */}
                            <span className={hasDiscount ? (itemData.isEnable ? s.crossOutPrice : s.crossOutPriceMuted) : (itemData.isEnable ? s.priceColor : 'text-muted')}>
                              <CurrencyConverter from={profile.preferredCurrency} toCurrency={profile.preferredCurrency} amount={itemPrice} />
                            </span>
                            {/* Discounted price */}
                            {hasDiscount &&
                              <span className={itemData.isEnable ? s.priceColor : 'text-muted'}>
                                <CurrencyConverter from={profile.preferredCurrency} toCurrency={profile.preferredCurrency} amount={itemPriceWithDiscount} />
                              </span>
                            }
                          </div>
                          {itemData && this.isValueDefined(itemData.tax || itemData.shopTax) &&
                            <span className={s.subText}>(<FormattedMessage {...messages.includesTax} />)</span>
                          }
                          {profile && profile.deliveryType !== 3 && itemTypeLabels[itemData.itemType] &&
                            <div className={s.vegBadge}>
                              <img src={itemTypeIcons[itemData.itemType]} className={s.vegIcon} alt='type icon' />
                              <span className="small">{formatMessage(itemTypeLabels[itemData.itemType])}</span>
                            </div>
                          }
                        </div>
                      </div>

                      {/* Right: duplicate (desktop) + action dropdown */}
                      <div className={s.itemActions}>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className={cx(s.duplicateBtn, 'align-items-center gap-1')}
                          disabled={duplicatingId === itemData.id}
                          onClick={() => this.handleDuplicate(itemData.id)}
                        >
                          {duplicatingId === itemData.id
                            ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            : <FiCopy size={13} />
                          }
                          {formatMessage(messages.duplicateItem)}
                        </Button>
                        <Dropdown>
                          <Dropdown.Toggle variant="outline-secondary" size='sm' disabled={duplicatingId === itemData.id}>
                            {duplicatingId === itemData.id
                              ? <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" /> {formatMessage(messages.editItem)}</>
                              : formatMessage(messages.editItem)
                            }
                          </Dropdown.Toggle>
                          <Dropdown.Menu alignRight className={s.dropdownMenu}>
                            <div className={s.dropdownSwitchItem}>
                              <span className={s.dropdownSwitchLabel}>
                                {itemData.isEnable ? formatMessage(messages.active) : formatMessage(messages.inactive)}
                              </span>
                              <SwitchButton
                                value={itemData.isEnable ? '1' : '0'}
                                handleSwitch={(e) => this.handleStatus(itemData.id, String(e), currentPage)}
                                switchOnLabel={''}
                                switchOffLabel={''}
                              />
                            </div>
                            <Dropdown.Divider />
                            <Dropdown.Item
                              className={cx(s.dropdownItem, s.dropdownItemMobileOnly)}
                              disabled={duplicatingId === itemData.id}
                              onClick={() => this.handleDuplicate(itemData.id)}
                            >
                              {duplicatingId === itemData.id
                                ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                : <FiCopy size={14} />
                              }
                              {formatMessage(messages.duplicateItem)}
                            </Dropdown.Item>
                            <Dropdown.Item
                              className={s.dropdownItem}
                              href={"/store/menu/" + itemData.menuId + "/item/" + itemData.subMenuId + "/edit/" + itemData.id}
                            >
                              <FiEdit2 size={14} />
                              {formatMessage(messages.editItem)}
                            </Dropdown.Item>
                            <Dropdown.Item
                              className={s.dropdownItem}
                              onClick={() => this.openMoveModal(itemData.id, itemData.itemName)}
                            >
                              <FiArrowRight size={14} />
                              {formatMessage(messages.moveItemTitle)}
                            </Dropdown.Item>
                            <Dropdown.Item
                              className={cx(s.dropdownItem, s.dropdownItemDelete)}
                              onClick={() => openModal('itemDeleteModal', { id: itemData.id, modalName: 'itemDeleteModal', currentPage })}
                            >
                              <FiTrash2 size={14} />
                              {formatMessage(messages.deleteAction)}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))
          }

          {itemDetails && itemDetails.getAllSubMenu && itemDetails.getAllSubMenu.results.length === 0 &&
            <span className={rs.notFoundText}><FormattedMessage {...messages.noSubMenu} />.</span>
          }

          <div className="clearfix"></div>

          {!hideSearchAndPagination && itemDetails && itemDetails.getAllSubMenu && itemDetails.getAllSubMenu.count > 10 &&
            <div className={cx(s.space5, s.spaceTop5, 'store')}>
              <CustomPagination
                total={itemDetails.getAllSubMenu.count}
                currentPage={currentPage}
                defaultCurrent={1}
                defaultPageSize={10}
                change={this.paginationData}
                paginationLabel={formatMessage(messages.subMenus)}
              />
            </div>
          }
        </Container>
      </div>
    );
  }
}

const mapDispatch = {
  deleteItem,
  duplicateItem,
  moveItem,
  fetchMenusAndSubmenus,
  updateItemStatus,
  editItem,
  openSubMenuModal,
  updateSubMenuStatus,
  deleteSubMenu,
  duplicateSubMenu,
  editSubMenu,
  openModal,
  closeModal
};
const mapState = (state) => ({
  subMenuDeleteModal: state.modalStatus.subMenuDeleteModal,
  itemDeleteModal: state.modalStatus.itemDeleteModal,
  copySubMenuModal: state.modalStatus.copySubMenuModal,
  modalData: state.modalStatus.data && state.modalStatus.data[0],
  profile: state.account.data && state.account.data.profile,
});

export default injectIntl(withStyles(s, rs)(connect(mapState, mapDispatch)(ItemList)));
